/* eslint-disable import/no-named-as-default */
import React, { FunctionComponent } from "react";
import { Provider } from "react-redux";
import store from "../../store";
import PendingReviews from "./PendingReviews";

const ProviderComponent: FunctionComponent<unknown> = () => (
  <Provider store={store}>
    <PendingReviews />
  </Provider>
);

export default ProviderComponent;
